import * as React from "react";

import type { DesignaliProps } from "../../types";

export const BehanceFull = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="6.51"
        fill="currentColor"
        viewBox="0 0 24 6.51"
        {...props}
        ref={forwardedRef}
      >
        <path
          strokeWidth={0}
          d="M2,1.41c.57,0,1.13,0,1.7,0,.19,0,.38.03.57.07.31.07.53.26.59.59.06.35,0,.67-.31.89-.05.03-.09.06-.15.1.02,0,.04.02.05.02.42.17.65.55.6,1-.06.49-.35.78-.89.89-.16.03-.32.04-.47.04-.53,0-1.05,0-1.58,0-.03,0-.06,0-.09,0,0-1.2,0-2.4,0-3.6ZM2.81,3.42v.98c.34,0,.68,0,1.02,0,.08,0,.18-.05.25-.1.19-.14.2-.34.15-.54-.05-.21-.21-.32-.41-.33-.33-.02-.67,0-1.01,0ZM2.81,2.03v.84c.3,0,.6.01.89,0,.27-.01.4-.18.4-.44,0-.25-.15-.39-.41-.39-.29,0-.58,0-.88,0Z"
        />
        <path
          strokeWidth={0}
          d="M10.65,5.02h-.72s0-.07,0-.1c0-.45,0-.9,0-1.35,0-.14-.03-.28-.06-.42-.04-.13-.14-.2-.28-.23-.39-.07-.64.14-.65.57-.01.36,0,.73,0,1.09,0,.15,0,.29,0,.44h-.72V1.42h.72v1.32c.14-.19.33-.31.55-.37.23-.06.47-.05.69.04.29.11.42.35.46.65.01.1.02.21.02.31,0,.53,0,1.06,0,1.58,0,.02,0,.04,0,.08Z"
        />
        <path
          strokeWidth={0}
          d="M13.56,5.03c-.24,0-.46,0-.69,0-.03,0-.06-.04-.07-.07-.02-.04-.02-.09-.04-.15-.03.02-.05.04-.08.06-.41.28-.85.31-1.3.11-.29-.13-.39-.39-.39-.69,0-.37.2-.63.57-.71.28-.06.56-.09.85-.14.04,0,.09-.02.13-.03.16-.06.2-.12.2-.25,0-.15-.08-.26-.21-.3-.15-.05-.3-.05-.45-.01-.15.04-.23.15-.27.29,0,.03-.04.07-.07.07-.22,0-.43,0-.66,0,0-.19.05-.35.18-.49.18-.21.42-.3.68-.34.3-.05.59-.04.88.02.14.03.27.09.39.17.19.12.25.33.25.55,0,.43,0,.87,0,1.3,0,.21,0,.42.11.63ZM12.72,3.79c-.14.03-.29.06-.44.09-.1.02-.21.04-.31.07-.17.05-.27.19-.25.36.01.16.12.28.3.29.12.01.24,0,.36-.01.19-.04.33-.19.35-.38.01-.14,0-.28,0-.41Z"
        />
        <path
          strokeWidth={0}
          d="M22,3.9h-1.89c-.03.42.31.71.74.65.2-.03.36-.12.47-.3.01-.02.04-.04.07-.04.19,0,.37,0,.57,0-.02.05-.03.08-.04.12-.24.62-.77.82-1.36.76-.32-.03-.61-.15-.83-.4-.2-.22-.3-.49-.33-.78-.04-.41.03-.79.3-1.11.23-.28.53-.42.88-.46.25-.02.49,0,.71.11.48.26.66.69.71,1.2,0,.08,0,.15,0,.25ZM21.29,3.44c-.05-.4-.31-.61-.68-.55-.3.05-.52.3-.47.55h1.15Z"
        />
        <path
          strokeWidth={0}
          d="M7.9,3.89h-1.88c-.05.26.13.56.38.63.26.08.66.05.83-.27,0-.02.04-.03.06-.03.19,0,.38,0,.57,0,0,.02,0,.04,0,.05-.16.45-.47.74-.95.82-.26.04-.52.03-.77-.06-.48-.17-.74-.53-.81-1.03-.06-.38-.01-.75.21-1.08.23-.35.57-.54.98-.57.24-.02.48,0,.69.11.43.22.65.59.69,1.06.01.12,0,.24,0,.38ZM6.03,3.44h1.16c-.04-.39-.28-.58-.66-.55-.3.03-.53.27-.5.55Z"
        />
        <path
          strokeWidth={0}
          d="M14.55,5.04h-.72v-2.63h.7v.35s.03-.02.03-.03c.25-.43.95-.49,1.33-.28.27.15.38.41.39.69.02.47.02.95.02,1.42,0,.15,0,.3,0,.45h-.72s0-.07,0-.1c0-.44,0-.89,0-1.33,0-.1,0-.21-.03-.31-.05-.24-.17-.35-.37-.37-.27-.02-.49.09-.56.31-.04.1-.06.22-.06.33,0,.46,0,.91,0,1.37,0,.04,0,.08,0,.13Z"
        />
        <path
          strokeWidth={0}
          d="M19.18,4.02c-.08.63-.5,1.03-1.12,1.07-.46.03-.87-.09-1.18-.46-.26-.31-.33-.68-.28-1.07.04-.37.18-.7.48-.95.49-.41,1.31-.34,1.73.01.22.18.31.42.33.7h-.7s-.01-.04-.02-.05c-.08-.38-.5-.54-.82-.31-.17.12-.25.3-.28.5-.04.22-.03.45.04.66.11.32.37.47.69.41.23-.05.37-.2.42-.44,0-.03.04-.07.06-.08.21,0,.42,0,.64,0Z"
        />
        <path strokeWidth={0} d="M5.86,2v-.34h1.46v.34h-1.46Z" />
      </svg>
    );
  },
);

export default BehanceFull;
